import { render, staticRenderFns } from "./SelectStickerMenu.vue?vue&type=template&id=09755ab0&"
import script from "./SelectStickerMenu.vue?vue&type=script&lang=js&"
export * from "./SelectStickerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports